import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import "./category.css";
import { withRouter } from "react-router-dom";
import * as Actions from "../../actions/index";
import { connect } from "react-redux";

class CategoryList extends Component {
  constructor() {
    super();
  }
  goToProfessionals(params) {
    this.props.doCatchCategory(params._id);
    console.log(params._id);

    this.props.history.push({
      pathname: `categoria/${params._id}/profissionais`,
      state: { category: params }
    });
  }
  render() {
    //console.log('list', this.props.list)
    return (
      <Row className="category-list category-container">
        {this.props.list.map((item, index) => {
          return (
            <Col
              lg="4"
              md="6"
              className="item"
              key={index.toString()}
              onClick={() => this.goToProfessionals(item)}
            >
              <img src={require("../../imagens/categorias/direito.jpg")} />
              <div className="item-texto">
                <p className="category"> {item.name} </p>
                <div>
                  <p>{item.online_count}</p>
                  <span className="icone"></span>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    doCatchCategory: category => dispatch(Actions.catchCategory(category))
  };
};
export default connect(null, mapDispatchToProps)(withRouter(CategoryList));
